export const getCommonItems = (arr1, arr2) => {
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);
  return Array.from(set1).filter((item) => set2.has(item));
};

export const generateRandomNumberString = (length) => {
  let result = "";
  const characters = "0123456789";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export const standardFormatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const setCrmSetting = ({ sku_id, product_id, product_url }) => {
  if (typeof window !== "undefined") {
    window.crmSetting = {
      "Logo_IMG": "logo.svg",
      "is_Action_url": "order/update",
      "is_CRM": true,
      "login_user_id": "cVk3eEk5cDJucUZyR2p4SlJ0N2NEUT09",
      "referral_id": "O1RFZ8",
      "form_action": "edit",
      "is_Edit": true,
      "is_quote_Edit": 0,
      "module_id_string": '',
      "sub_module": "",
      "sub_module_id": "",
      "is_module_id": "b2NLS2ZHYURCL3R5WnlVVzQ2MUxZZz09",
      "is_module_name": "inventory",
      "duplicate_module": "",
      "web_url": "https://crm.senseicrm.com",
      "selected_sub_module": "0",
      "company_name": "EMB Metal Buildings, LLC",
      "gTag": false,
      "orderColor": "#D12029",
      "sku_id": sku_id,
      "is_loggedin": true,
      "price_api_url": "https://api.senseicrm.com/",
      "header_key": {
        "x-api-key": "9vZYfym4VG99tLmdoqWYI8TYW01klRpr7ywM7SA5"
      },
      "order_now": true,
      "BuisnessName": "Sensei CRM",
      // "crm_product_id": "MTQ4Mzg=",
      "crm_product_id": product_id,
      "api_token": "gkpqMKaEhZXlTYqsCRtGjDn96HvVzrNHf2wRwYL5B6p1QRrSXZLTOCpUeCnyimZ1",
      "parent_api_token": "gkpqMKaEhZXlTYqsCRtGjDn96HvVzrNHf2wRwYL5B6p1QRrSXZLTOCpUeCnyimZ1",
      "stripe_detail": {
        "enabled": "yes",
        "testmode": "yes",
        "test_publishable_key": "pk_test_rdFjxhfdgUp51mDhmHz2VjTL",
        "test_secret_key": "",
        "publishable_key": "",
        "secret_key": ""
      },
      "api_post_url": "https://crm.senseicrm.com",
      "email": "sales@embmetalbuildings.com",
      "phone_number": "(208) 718-5219",
      "source": "https://crm.senseicrm.com",
      "form": "Inventory",
      // "page": "https://crm.senseicrm.com/inventory/3d_edit/b2NLS2ZHYURCL3R5WnlVVzQ2MUxZZz09",
      "page": product_url,
      "menu_address": "340 Centennial Drive Heyburn, Idaho 83336",
      "main_domain_url": "engineeredmetalbuildings.com",
      "pre_quote_form": false,
      "is_zipcode_screen": false,
      "navigation_url": {
        "lead": "https://crm.senseicrm.com/leads",
        "quote": "https://crm.senseicrm.com/quotes",
        "my_account": "https://crm.senseicrm.com/settings/personal",
        "post": "https://crm.senseicrm.com/posts-sensei/K2ZZeEZPa0VLKzZ3TkxVR1dsUlo2Zz09",
        "my_team": "https://crm.senseicrm.com/users",
        "logout": "https://crm.senseicrm.com/logout",
        "report_error": "https://crm.senseicrm.com/tickets"
      },
      "is_klink_generated": 0,
      "has_customer_permission": "1",
      "is_CRM_V4": true,
      "latest_api_url": "https://gateway.senseicrm.com/",
      "discount_api_url": "https://gateway.senseicrm.com/",
    };
  }
};

export const embedCrmScript = ({ id, src }) => {
  if (typeof window !== "undefined") {
    const existingScript = document.getElementById(id);
    if (existingScript) existingScript.remove();

    const newScript = document.createElement("script")
    newScript.src = src;
    newScript.id = id;
    newScript.async = true
    document.body.appendChild(newScript);
  }
};